import TooltipOferta from "./tooltipOferta";

export default TooltipOferta;
